export const shop = [
    {
      "id":0,
      "Name":"KIMONO BLANCO ADULTO", 
      "Description":"Kimono blanco liso talles diferentes", 
      "Precio":"~ $16.000", 
      "Link": "https://mpago.la/2DGgE3i"
    },
    {
        "id":1,
        "Name":"KIMONO BLANCO KIDS", 
        "Description":"Kimonos blanco liso excelente calidad", 
        "Precio":"~ $9.000", 
        "Link": "https://mpago.la/29U5yYP"
    }
  ]